import dashboardIcon from "@assets/icons/navlinks/dashboard.svg";
import regulatorFillingIcon from "@assets/icons/navlinks/regulator_filling.svg";
import importExportIcon from "@assets/icons/navlinks/import_export.svg";
import otherInsightsIcon from "@assets/icons/navlinks/other_insights.svg";
import productInsightsIcon from "@assets/icons/navlinks/product_insights.svg";
import dashboardActiveIcon from "@assets/icons/navlinks/dashboard_active.svg";
import settingsIcon from "@assets/icons/navlinks/settings.svg";
import searchIcon from "@assets/icons/navlinks/search.svg";
import regulatorFillingActiveIcon from "@assets/icons/navlinks/regulator_filling_active.svg";
import importExportActiveIcon from "@assets/icons/navlinks/import_export_active.svg";
import otherInsightsActiveIcon from "@assets/icons/navlinks/other_insights_active.svg";
import productInsightsActiveIcon from "@assets/icons/navlinks/product_insights_active.svg";
import settingsActiveIcon from "@assets/icons/navlinks/settings_active.svg";
import searchActiveIcon from "@assets/icons/navlinks/search_active.svg";
import analyticsIcon from "@assets/icons/navlinks/analytics.svg";
import analyticsActiveIcon from "@assets/icons/navlinks/analytics_active.svg";

import { ADMIN, USER } from "@utils/roleRights";

export const NAVLINKS = [
  // {
  //   label: "Leadership Dashboard",
  //   path: "/dashboard",
  //   icon: dashboardIcon,
  //   activeIcon: dashboardActiveIcon,
  //   activeOnOtherPaths: ["/"],
  // },
  {
    label: "Product Dashboard",
    path: "/product_insights",
    icon: productInsightsIcon,
    activeIcon: productInsightsActiveIcon,
    activeOnOtherPaths: [],
    allowedRoles: [ADMIN, USER],
  },
  {
    label: "MI Analytics",
    path: "/advance_search",
    icon: analyticsIcon,
    activeIcon: analyticsActiveIcon,
    activeOnOtherPaths: [],
    allowedRoles: [ADMIN, USER],
  },
  {
    label: "Import & Export",
    path: "/import_export",
    icon: importExportIcon,
    activeIcon: importExportActiveIcon,
    activeOnOtherPaths: [],
    allowedRoles: [ADMIN, USER],
  },
  {
    label: "Regulatory Filings",
    path: "/regulator_filling",
    icon: regulatorFillingIcon,
    activeIcon: regulatorFillingActiveIcon,
    activeOnOtherPaths: [],
    allowedRoles: [ADMIN, USER],
  },
  {
    label: "Other Insights",
    path: "/other_insights",
    icon: otherInsightsIcon,
    activeIcon: otherInsightsActiveIcon,
    activeOnOtherPaths: [],
    allowedRoles: [ADMIN, USER],
  },
  {
    label: "Settings",
    path: "/settings",
    icon: settingsIcon,
    activeIcon: settingsActiveIcon,
    activeOnOtherPaths: [],
    allowedRoles: [ADMIN],
  },
];
